module.exports = __webpack_public_path__ + "static/img/percentage.0f67b7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/percentage.png
// module id = IO65
// module chunks = 2